/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    // Add custom code below this line
    function customTooltip(){
        let tooltipContainers = document.querySelectorAll('div.tooltip-container');
        tooltipContainers.forEach((tooltipContainer)=>{
            let classSwitcher = false;
            let infoCta = tooltipContainer.querySelector('.open_tooltip'),
                tooltip = tooltipContainer.querySelector('.box_tooltip');
            infoCta.addEventListener('click', ()=>{
                classSwitcher = !classSwitcher
                classSwitcher ? tooltip.classList.add('visible') : tooltip.classList.remove('visible')
            })
        })

    }
    customTooltip();
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
  })();
